import customer from "./customer/index.js";
import employee from "./employee/index.js";
import general from "./general.js";

export default [
  ...customer.routes,
  ...employee.routes,
  ...general.routes,
  {
    name: "auth",
    path: "/auth",
    component: () => import("pages/Auth"),
  },
  {
    name: "404",
    path: "/:catchAll(.*)*",
    component: () => import("pages/Error404"),
  },
];

export const dialogs = [
  ...customer.dialogs,
  ...employee.dialogs,
  ...general.dialogs,
];
